import { FunctionComponent, lazy } from 'react'
import { NPSProvider } from './contexts/NPSContext'
import { Route, Switch } from 'react-router-dom'

const ConsultationRating = lazy(
  () => import('@/modules/NPS/pages/ConsultationRating'),
)
const ConsultationRatingSuccess = lazy(
  () => import('@/modules/NPS/pages/ConsultationRatingSuccess'),
)
const AttendedAppointment = lazy(
  () => import('@/modules/NPS/pages/AttendedAppointment'),
)
const Checkout = lazy(() => import('@/modules/NPS/pages/Checkout'))

const MissedAppointment = lazy(
  () => import('@/modules/NPS/pages/MissedAppointment'),
)
const PlatformRating = lazy(() => import('./pages/PlatformRating'))

const PlatformRatingSuccess = lazy(
  () => import('./pages/PlatformRatingSuccess'),
)

const routes = [
  <Route
    path="/avaliacao/plataforma"
    key="/avaliacao/plataforma"
    exact
    component={PlatformRating}
  />,
  <Route
    path="/avaliacao/plataforma/sucesso"
    key="/avaliacao/plataforma/sucesso"
    exact
    component={PlatformRatingSuccess}
  />,
  <Route
    path="/avaliacao/:consultationId"
    key="/avaliacao/:consultationId"
    exact
    component={ConsultationRating}
  />,
  <Route
    path="/avaliacao/:consultationId/app/:platform"
    key="/avaliacao/:consultationId"
    exact
    component={ConsultationRating}
  />,
  <Route
    path="/avaliacao/:consultationId/sucesso"
    key="/avaliacao/:consultationId/sucesso"
    exact
    component={ConsultationRatingSuccess}
  />,
  <Route
    path="/avaliacao/:consultationId/app/:platform/sucesso"
    key="/avaliacao/:consultationId/app/:platform/sucesso"
    exact
    component={ConsultationRatingSuccess}
  />,
  <Route
    path="/avaliacao/:consultationId/realizada"
    key="/avaliacao/:consultationId/realizada"
    exact
    component={AttendedAppointment}
  />,

  <Route
    path="/avaliacao/:consultationId/nao-realizada"
    key="/avaliacao/:consultationId/nao-realizada"
    exact
    component={MissedAppointment}
  />,
  <Route
    path="/avaliacao/:consultationId/resultado"
    key="/avaliacao/:consultationId/resultado"
    exact
    component={Checkout}
  />,
]

const NPSRoutes: FunctionComponent = () => (
  <NPSProvider>
    <Switch>{routes}</Switch>
  </NPSProvider>
)

export default NPSRoutes
